import TextField from "./common/textField"

const NoteField = () => {
    return (
        <TextField 
            name={"note"}
            label={"facilityReservationForm.form.label.note"}
            maxLength={1000}
            minRows={4}
            title={"facilityReservationForm.form.label.note"}
        />
    )
}

export default NoteField;
